import axios from "axios";
import Vue from "vue";

window.Vue = Vue;

window.addEventListener("DOMContentLoaded", function () {
    new Vue({
        el: "#contact",
        data: function () {
            return {
                prefix:"40",
                errorMessage_phone:'',
                phone:null,
                loading:false,
                responseText:false,
                errorMessage_city:'',
                area:null,
                area_zone:null,
                area_city:null
            };
        },
        methods: {
            chooseDropdownValue(event) {
                let target = event.target;
                let options = target.options;
                let selectedIndex = options.selectedIndex;
                let selectedOption = options[selectedIndex] || null;
                this.area_zone = selectedOption
                    ? selectedOption.getAttribute("data-zone")
                    : null;
                this.area = selectedOption.value;    
                this.area_city = selectedOption.text;    
            },
            sendEmail(language){
                const vm = this;
                var city = '';
                // var phoneNumber = 
                // vm.prefix=='others' && vm.custom_prefix!=null?
                // vm.custom_prefix+vm.phone: vm.prefix + vm.phone;
                var phoneNumber =  vm.formatRomaniaPhoneNumber(vm.phone);
                var checkValid = true;
                if (vm.phone == null || vm.phone == "" ) {
                    vm.errorMessage_phone = "can't be empty";
                    checkValid =false;
                } else if (vm.phone!=null && this.phone!='' && !vm.validatePhoneNumber(phoneNumber)) {
                    checkValid = false;
                    vm.errorMessage_phone = "not valid";
                } else {
                    vm.errorMessage_phone = "";
                }
                if(language == 'ro'){
                    if (vm.area_city == null || vm.area_city == "" ) {
                        vm.errorMessage_city = "Can't be empty";
                        checkValid =false;
                    }  else {
                        vm.errorMessage_city = "";
                    }
                    var city = '&city='+vm.area_city;

                }
                if(checkValid)
                {
                    vm.loading = true;
                    vm.responseText = false;

                     axios
                    .get("/api/sendEmailAndMessage?&phone=" +phoneNumber+'&language='+language+city)
                    .then((response) => {
                        vm.responseText = true;
                    })
                    .catch((error)=>{
                        vm.responseText =false;
                    })
                    .then(()=>{
                        vm.loading=false;
                    });
                }   
                },

             validatePhoneNumber(str) {
                var phoneNumber = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,8}$/im.test(str);
                return phoneNumber;
              },

              formatRomaniaPhoneNumber(str) {
                if (str == null || str == "" ) {
                    return null;
                }
                let phoneNumber = str.replace(/\D/g, '');
                if(phoneNumber.length==10 && phoneNumber[0]==0){
                    phoneNumber = "4"+phoneNumber;
                }
                if(phoneNumber.length==9 && phoneNumber[0]==7){
                    phoneNumber = "40"+phoneNumber;
                }
                return phoneNumber;
              }
              
              
        },
    });
});
